import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import residuo_api from '../../../api/residuo_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import mascaras from '../../../helpers/mascaras';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';


//Estado inicial do residuo
function initialStateResiduo() {
    return {
        descricao: "",
        status: "Ativo",
        densidade: ""
    }
}

export default function Residuos({ permissao }) {
    //Estado que guarda os dados de Cadastro/Edição de um residuo
    const [residuo, setResiduo] = useState(initialStateResiduo());

    //Estado que faz o controle do modal de Cadastro/Edição
    const [openModal, setOpenModal] = useState(false);

    //Estado que faz o controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios
    const campos = [objCampo({ name: "descricao", required: true })];

    //Troca o estado de exibição do modal
    const toggleModal = () => {
        if (openModal) {
            setResiduo(initialStateResiduo);
            setErrors({});
        }
        setOpenModal(!openModal);
    };

    //Guarda os residuos que vão ser listados na tela
    const [residuos, setResiduos] = useState([]);

    //Faz o controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Carrega todos os residuos que vão ser listados na tabela
    const loadResiduos = () => {
        setLoading(true);
            residuo_api.GetList().then(response => {
                setResiduos(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega os residuos que vão ser listados assim que o componente é inicializado
    useEffect(() => {
        loadResiduos();
    }, [])

    //Change para os campos de Cadastro/Edição de um residuo
    const onChangeResiduo = (e) => {
        const { name, value } = e.target;
        const _residuo = {
            ...residuo,
            [name]: value
        }
        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_residuo, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors({ ..._errors });
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setResiduo(_residuo)
    }

    //Adiciona/Edita um residuo
    const addNovoResiduo = () => {
        const _residuo = { ...residuo };

        const erros = validarCampos(_residuo, campos);
        if (erros[1].length) {
            setErrors(erros[0]);
            return;
        }
        setLoading(true);
        if (!_residuo.id) {
            residuo_api.Post(_residuo).then(response => {
                showMessage("Sucesso", "Sucesso ao adicionar o residuo", "success");
                loadResiduos();
                setResiduo(initialStateResiduo());
                toggleModal();
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        } else {
            residuo_api.Put(_residuo).then(response => {
                showMessage("Sucesso", "Sucesso ao editar o residuo", "success");
                loadResiduos();
                setResiduo(initialStateResiduo());
                toggleModal();
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //Salva os dados para serem editados no modal
    const editarResiduo = (item) => {
        setLoading(true);
        residuo_api.GetItem(item.id).then(response => {
            setResiduo(response.data);
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));

    }

    //Variavel que guarda as ações da tabela
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editarResiduo));

    //Cabeçalhos da tabela 
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
    ]

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized title={residuo.id ? <><FontAwesomeIcon icon={faEdit} /> Editar tipo de resíduo</> : "Novo tipo de resíduo"} isOpen={openModal} toggle={toggleModal} btnAction={residuo.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} btnActionColor={residuo.id ? "warning text-light" : "success"} onClickBtnAction={addNovoResiduo} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField
                                maxLength={"50"}
                                invalid={errors.descricao ? true : false}
                                label={"* Descrição"}
                                name="descricao"
                                value={residuo.descricao}
                                onChange={onChangeResiduo}
                            />
                            {errors.descricao && <span className={"form-control-label text-danger"}>{errors.descricao.message}</span>}
                        </Col>
                        <Col md="12" lg="3">
                            <TextField
                                label={"Status"}
                                type={"select"}
                                options={[{ text: "Ativo", value: "Ativo" }, { text: "Inativo", value: "Inativo" }]}
                                name="status"
                                value={residuo.status}
                                onChange={onChangeResiduo}
                            />
                        </Col>
                        <Col md="12" lg="3">
                            <TextField
                                mask={mascaras.floatMask}
                                invalid={errors.densidade ? true : false}
                                label={"Densidade"}
                                name={"densidade"}
                                value={residuo.densidade}
                                onChange={onChangeResiduo}
                            />
                        </Col>
                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem
                        actions={actions}
                        title={"Lista de resíduos"}
                        options={{ print: false, search: true, pagination: true }}
                        items={residuos}
                        headers={headers}
                    />
                </div>
            </MainCard>
        </>
    )
}